export const stylesSort = [
    'Shield',
    'Bar',
    'R-End',
    'R-Cnr',
    '20mm Disc',
    '30mm Disc',
    '20mm Star',
    '30mm Star',
];

export const styleSizes = {
    ['Shield']: ' (30 x 28mm)',
    ['R-End']: ' (45 x 9mm)',
    ['Bar']: ' (38 x 8mm)',
    ['R-Cnr']: ' (44 x 13mm)',
};